<template>
  <div></div>
</template>

<script>

export default {
  name: 'likeWord',
  props: ['article', 'articleInfo', 'carForm', 'searchContent'],
  data () {
    return {
      chooseTxt: '',
      showSummary: false,
      historyIndex: 0,
      historyArray: [],
      advertTab: '近义词',
      likeWordMap: {},
      sourceKeyword: '',
      targetKeyword: '',
      appendContent: '',
      likeWordKeyWord: '',
      searchSentenceRes: {},
      sentenceForm: {},
      articleContentArray: []
    }
  },
  watch: {
    searchContent: function () {
      console.log('近义词,选择的内容', this.searchContent)
      this.seachLikeWord()
    }
  },
  mounted () {

  },
  components: {

  },
  methods: {
    chooseLikeWord (k, p) { // 选择近义词,展现所有
      this.likeWordKeyWord = k
      this.$emit('chooseLikeWord', this.likeWordKeyWord, p)
    },
    toReplaceLikeWord (val) { // 点击备选词，进行替换
      delete this.likeWordMap[this.likeWordKeyWord]
      this.$emit('toReplaceLikeWord', this.likeWordKeyWord, val)
    },

    closeDialog () {
      this.$emit('closeDialog')
    },

    replaceAllLikeWord () { // 近义词 替换所有
      if (this.targetKeyword.indexOf(this.sourceKeyword) > -1) {
        this.$message.error('被替换的词中，不能包含原词')
        return
      }
      let replaceRes = false
      if (this.sourceKeyword) {
        for (var i = 0; i < this.articleContentArray.length; i++) {
          while (this.articleContentArray[i].indexOf(this.sourceKeyword) > -1) {
            this.articleContentArray[i] = this.articleContentArray[i].replace(this.sourceKeyword, this.targetKeyword)
            replaceRes = true
          }
        }
      } else {
        this.$message.error('被替换的关键词不能为空')
        return
      }
      if (replaceRes) {
        this.pushToHistoryArray()
        this.$message({
          message: '替换完成',
          type: 'success'
        })
      } else {
        this.$message.error('未找到要替换的关键词')
      }
      this.$forceUpdate()
    }

  }
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/article/likeWord.vue